import React, { useState } from 'react';

// Названия ключей СТРОГО совпадают с бэкендом (api/app/manual_scores.py)
const CUBE_CRITERIA = [
  { key: "threeDimensional", label: "Куб объёмный (3D)?" },
  { key: "allLinesPresent", label: "Все линии и грани на месте?" },
  { key: "noExtraLines", label: "Нет лишних линий?" },
  { key: "linesParallelAndEqual", label: "Линии параллельны и равны?" }
];

// Часы: 3 критерия по 1 баллу (макс. 3)
const CLOCK_CRITERIA = [
  {
    key: "contourPresent",
    label: "Контур: циферблат круглый?"
  },
  {
    key: "allNumbersCorrect",
    label: "Цифры: все на месте, в правильном порядке, лишних нет?",
    hint: "Цифры могут быть расположены вне контура."
  },
  {
    key: "handsCorrect",
    label: "Стрелки: две, показывают 10 минут двенадцатого, расположены по центру?",
    hint: "Часовая стрелка короче минутной."
  }
];

export default function DrawingChecklist({ itemId, onSubmit }) {
  const criteria = itemId === '2a' ? CUBE_CRITERIA : CLOCK_CRITERIA;
  const [answers, setAnswers] = useState({});

  const handleToggle = (key, val) => {
    setAnswers({ ...answers, [key]: val });
  };

  const handleSubmit = () => {
    const allAnswered = criteria.every(c => answers[c.key] !== undefined);
    if (!allAnswered) {
      alert("Пожалуйста, ответьте на все вопросы.");
      return;
    }
    // Отправляем объект с булевыми значениями (true/false)
    onSubmit(itemId, answers);
  };

  return (
    <div className="flex flex-col gap-2 text-left p-2 bg-secondary/20 rounded-lg border border-border">
      {criteria.map((c) => (
        <div key={c.key} className="flex items-center justify-between gap-2">
          <div className="flex flex-col">
            <span className="text-xs text-primary">{c.label}</span>
            {c.hint && <span className="text-[10px] text-muted-foreground">{c.hint}</span>}
          </div>
          <div className="flex gap-1">
            <button 
              onClick={() => handleToggle(c.key, true)} 
              className={`px-2 py-0.5 text-xs rounded ${answers[c.key] === true ? 'bg-green-500 text-white' : 'bg-background text-muted-foreground border border-border'}`}
            >Да</button>
            <button 
              onClick={() => handleToggle(c.key, false)} 
              className={`px-2 py-0.5 text-xs rounded ${answers[c.key] === false ? 'bg-red-500 text-white' : 'bg-background text-muted-foreground border border-border'}`}
            >Нет</button>
          </div>
        </div>
      ))}
      <button 
        onClick={handleSubmit} 
        className="mt-2 bg-primary text-white text-xs py-1 rounded hover:bg-primary/90"
      >
        Сохранить оценку
      </button>
    </div>
  );
}